import { render, staticRenderFns } from "./CavityDialog.vue?vue&type=template&id=788dc415&scoped=true"
import script from "./CavityDialog.vue?vue&type=script&lang=js"
export * from "./CavityDialog.vue?vue&type=script&lang=js"
import style0 from "./CavityDialog.vue?vue&type=style&index=0&id=788dc415&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788dc415",
  null
  
)

export default component.exports